import { j as n } from "./jsx-runtime-3tyXYecC.mjs";
import { f as C } from "./index-LyFokDcn.mjs";
import { l as W } from "./lodash-5ofSKtz3.mjs";
import { useState as H, useRef as j, useImperativeHandle as S } from "react";
import { I as b } from "./icon-v2-DGtVEk7e.mjs";
import { m as I } from "./tss-DN0acMKN.mjs";
const m = (s, r) => {
  switch (s) {
    case "error":
      return r.constructs.surface.error.weak;
    case "warning":
      return r.constructs.surface.warning.weak;
    case "info":
      return r.constructs.surface.info.weak;
    case "success":
      return r.constructs.surface.success.weak;
    case "discovery":
      return r.constructs.surface.discovery.weak;
    default:
      return r.constructs.surface.neutral.xWeak;
  }
}, k = (s, r) => {
  switch (s) {
    case "error":
      return r.constructs.surface.error.medium;
    case "warning":
      return r.constructs.surface.warning.medium;
    case "info":
      return r.constructs.surface.info.medium;
    case "success":
      return r.constructs.surface.success.medium;
    case "discovery":
      return r.constructs.surface.discovery.medium;
    default:
      return r.constructs.surface.neutral.strong;
  }
}, p = (s, r) => {
  switch (s) {
    case "error":
      return r.constructs.surface.error.strong;
    case "warning":
      return r.constructs.surface.warning.strong;
    case "info":
      return r.constructs.surface.info.strong;
    case "success":
      return r.constructs.surface.success.strong;
    case "discovery":
      return r.constructs.surface.discovery.strong;
    default:
      return r.constructs.surface.neutral.xStrong;
  }
}, y = (s, r) => {
  switch (s) {
    case "error":
      return r.constructs.surface.error.strong;
    case "warning":
      return r.constructs.surface.warning.strong;
    case "info":
      return r.constructs.surface.info.strong;
    case "success":
      return r.constructs.surface.success.strong;
    case "discovery":
      return r.constructs.surface.discovery.strong;
  }
}, h = (s, r) => s && r.constructs.surface[s].weak ? r.constructs.surface[s].weak : r.constructs.surface.neutral.xWeak, z = I()((s, r, a) => {
  var x, i, u, l, d, v, w;
  const { borderRadiuses: f, constructs: c, spacing: t, typography: o } = s, { onRemove: g, status: e } = r;
  return {
    root: {
      backgroundColor: m(e, s),
      borderRadius: f[1e3],
      color: c.text.neutral.xStrong,
      display: "inline-flex",
      fontSize: (x = o.xsmall) == null ? void 0 : x.fontSize,
      fontWeight: o.fontWeightMedium,
      lineHeight: (i = o.xsmall) == null ? void 0 : i.lineHeight,
      maxHeight: (u = o.xsmall) == null ? void 0 : u.lineHeight,
      maxWidth: "300px",
      overflow: "hidden",
      padding: g ? `3px 0 3px ${t(1)}` : `3px ${t(1)}`,
      width: "fit-content",
      "&:focus-within": {
        backgroundColor: p(e, s),
        border: `3px solid ${h(e, s)}`,
        color: c.text.neutral.forcedWhite,
        margin: "-3px",
        [`& > .${a.icon}`]: {
          fill: c.text.neutral.forcedWhite
        }
      }
    },
    deleteIcon: {
      backgroundColor: m(e, s),
      border: "none",
      display: "flex",
      fill: y(e, s),
      lineHeight: (l = o.xsmall) == null ? void 0 : l.lineHeight,
      marginBottom: "auto",
      marginTop: "auto",
      padding: `3px ${t(1)}`,
      "&:active, &:focus": {
        backgroundColor: p(e, s),
        cursor: "pointer",
        fill: c.surface.neutral.forcedWhite
      },
      "&:focus-visible": {
        outline: "none"
      },
      "&:hover:not(:focus, :active)": {
        backgroundColor: k(e, s),
        fill: c.text.neutral.forcedWhite,
        cursor: "pointer"
      }
    },
    icon: {
      fill: y(e, s),
      marginRight: "6px",
      paddingTop: "2px"
    },
    label: {},
    hover: {
      backgroundColor: k(e, s),
      cursor: "pointer",
      borderRadius: f[1e3],
      color: c.text.neutral.forcedWhite,
      display: "flex",
      fontSize: (d = o.xsmall) == null ? void 0 : d.fontSize,
      fontWeight: o.fontWeightMedium,
      lineHeight: (v = o.xsmall) == null ? void 0 : v.lineHeight,
      maxHeight: (w = o.xsmall) == null ? void 0 : w.lineHeight,
      maxWidth: "300px",
      overflow: "hidden",
      padding: g ? `3px 0 3px ${t(1)}` : `3px ${t(1)}`,
      width: "fit-content",
      [`& > .${a.icon}`]: {
        fill: c.text.neutral.forcedWhite
      },
      "&:focus-within, &:active": {
        backgroundColor: p(e, s),
        border: `3px solid ${h(e, s)}`,
        color: c.text.neutral.forcedWhite,
        margin: "-3px"
      }
    }
  };
});
function T({
  apiRef: s,
  ariaLabel: r = window.jQuery ? $.__("remove") : "remove",
  icon: a,
  biId: f,
  id: c,
  label: t,
  onRemove: o,
  status: g
}) {
  const { classes: e } = z({ onRemove: o, status: g }), [x, i] = H(!1), u = W.uniqueId(), l = j(null);
  return S(
    s,
    () => ({
      focus: () => {
        var d;
        (d = l.current) == null || d.focus();
      }
    }),
    []
  ), /* @__PURE__ */ n.jsx(n.Fragment, { children: C.ifFeature(
    "encore",
    /* @__PURE__ */ n.jsxs("div", { className: x ? e.hover : e.root, "data-bi-id": f, "data-fabric-component": "Chip", id: c, children: [
      a && /* @__PURE__ */ n.jsx("div", { className: e.icon, children: /* @__PURE__ */ n.jsx(b, { name: a, size: 12 }) }),
      /* @__PURE__ */ n.jsx("div", { className: e.label, id: u, children: t }),
      o && /* @__PURE__ */ n.jsx(
        "button",
        {
          "aria-describedby": u,
          "aria-label": r,
          className: e.deleteIcon,
          onClick: o,
          onFocus: () => {
          },
          onMouseLeave: () => i(!1),
          onMouseOver: () => i(!0),
          ref: l,
          type: "button",
          children: /* @__PURE__ */ n.jsx(b, { name: "circle-x-solid", size: 12 })
        }
      )
    ] }),
    "Chip component is only available with Encore enabled."
  ) });
}
export {
  T as C
};
//# sourceMappingURL=chip-CiqpGbr-.mjs.map
